import { stageSize } from 'src/app/types/stageSize.type';

export const defaultSelectedStageSize: stageSize = {
  stageBreadth: 1,
  stageDepth: 1,
  stageHeight: 1,
};
